import './App.css';
import React from 'react';
import Hero from './components/hero/Hero';
import Programs from './components/Programs/Programs';
import Reasons from './components/Reasons/Reasons';
import Plans from './components/Plans/Plans';
import Testimonial from './components/Testimonial/Testimonial';
import Join from './components/Join/Join';
import Footer from './components/Footer/Footer';
import Contact from './components/Contact/Contact';
import End from './components/End/End';
function App() {
  return (
    <>
    <div className="App">
        <Hero />
        <Programs />
        <Reasons />
        < Plans />
        <Testimonial />
        <Join />
        <Contact />
        <Footer />

    </div>
    </>
  );
}

export default App;
